import { createSlice } from "@reduxjs/toolkit";
import { updateEnrollmentAgreementAPI } from "../../services/updateEnrollmentAgreement";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const updateEnrollmentAgreementSlice = createSlice({
  name: "updateEnrollmentAgreement",
  initialState,
  reducers: {
    updateEnrollmentAgreementInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    	updateEnrollmentAgreementInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "Enrollment Agreement saved successfully";
      state.error = "";
    },
    updateEnrollmentAgreementInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      const p = action.payload;
      state.error =
        typeof p === "string"
          ? p
          : p?.message != null
            ? String(p.message)
            : Array.isArray(p?.errors)
              ? p.errors.map(String).join(" ")
              : p != null
                ? String(p)
                : "Something went wrong";
      state.data = null;
    },
    updateEnrollmentAgreementInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const updateEnrollmentAgreementHandler =
  (payload) => async (dispatch) => {
    try {
      dispatch(
        updateEnrollmentAgreementAction.updateEnrollmentAgreementInfo(payload),
      );
      const response = await updateEnrollmentAgreementAPI(payload);
      dispatch(
        updateEnrollmentAgreementAction.updateEnrollmentAgreementInfoSuccess(
          response,
        ),
      );
    } catch (e) {
      const raw =
        typeof e === "string"
          ? e
          : e?.response?.data?.message ?? e?.message ?? e;
      dispatch(
        updateEnrollmentAgreementAction.updateEnrollmentAgreementInfoFailure(
          raw,
        ),
      );
    }
  };

export default updateEnrollmentAgreementSlice.reducer;
export const updateEnrollmentAgreementAction =
  updateEnrollmentAgreementSlice.actions;

